import { extendTheme } from '@chakra-ui/react';
import { PRIMARY_FONT, SECONDARY_FONT, ALTERNATIVE_FONT } from '@/constants/fonts';
import {
  BG_SECONDARY,
  BG_PRIMARY,
  BG_SECONDARY_DARK,
  BG_SECONDARY_TRANSPARENT,
  BG_ALTERNATIVE,
  TEXT_PRIMARY,
  TEXT_SECONDARY,
  TEXT_PRIMARY_DARK,
} from '@/constants/colors';

/**
 * override chackra-ui for personalize purpose
 * see the docs: https://chakra-ui.com/guides/using-fonts
 */
const theme = {
  fonts: {
    heading: PRIMARY_FONT,
    body: SECONDARY_FONT,
    fantasy: ALTERNATIVE_FONT,
    jost: `'Jost', serif`,
  },
  colors: {
    bgPrimary: BG_PRIMARY,
    bgSecondary: BG_SECONDARY,
    bgSecondaryColor: BG_SECONDARY,
    bgAlternative: BG_ALTERNATIVE,
    mainColor: BG_SECONDARY,
    mainColorText: TEXT_PRIMARY,
    mainColorDarkText: TEXT_PRIMARY_DARK,
    secondaryColorText: TEXT_SECONDARY,
    transparent: 'transparent',
    theme: {
      bgPrimaryText: TEXT_PRIMARY,
      bgPrimary: BG_PRIMARY,
      bgSecondary: BG_SECONDARY,
      bgSecondaryDark: BG_SECONDARY_DARK,
      bgSecondaryTransparent: BG_SECONDARY_TRANSPARENT,
    },
    button: {
      secondary: {
        500: BG_SECONDARY,
      },
      secondaryDark: {
        500: BG_SECONDARY_DARK,
      },
    },
  },
  shadows: {
    outline: BG_SECONDARY_DARK,
  },
};

export default extendTheme(theme);
